import { APP_CONFIG } from '../../app.config';
import { HttpHeaders } from '@angular/common/http';

export const AUTH_CONFIG = {
  requests: {
    getAccountInfo: {
      name: 'getAccountInfo',
      url: `${APP_CONFIG.apiBaseUrl}/account/info`,
    },
    requestForToken: {
      name: 'requestForToken',
      url: `${APP_CONFIG.apiBaseUrl}/oauth/token`,
    },
    refreshToken: {
      name: 'refreshToken',
      url: `${APP_CONFIG.apiBaseUrl}/oauth/token`,
    },
    requestForgottenPassword: {
      name: 'requestForgottenPassword',
      url: `${APP_CONFIG.apiBaseUrl}/account/forgot-password`,
    },
    clearUnreadNotifications: {
      name: 'clearUnreadNotifications',
      url: `${APP_CONFIG.apiBaseUrl}/notification/clear-all`,
    },
    markAsRead: {
      name: 'markAsRead',
      url: `${APP_CONFIG.apiBaseUrl}/notification/read`,
    },
    getAccountNotificationsStats: {
      name: 'getAccountNotificationsStats',
      url: `${APP_CONFIG.apiBaseUrl}/notification`,
    },
    getAccountNotifications: {
      name: 'getAccountNotifications',
      url: `${APP_CONFIG.apiBaseUrl}/notification`,
    },
    markAllAsRead: {
      name: 'markAllAsRead',
      url: `${APP_CONFIG.apiBaseUrl}/notification/read-all`,
    },
    logAction: {
      name: 'logAction',
      url: `${APP_CONFIG.apiBaseUrl}/logs`,
    },
  },
  headers: {
    authApiHeader: new HttpHeaders({
      'Content-type': 'application/x-www-form-urlencoded; charset=utf-8',
      Authorization: 'Basic ' + btoa('back_application:8~A-D"W#GvGserS<'),
    }),
  },
};
